<template>
  <div
    class="pagination-input"
    data-sb-regression="sb-pagination-input"
  >
    <p v-if="labelText">
      <sb-text :value="labelText" />
    </p>
    <sb-text-input
      v-model:value="pageNum"
      :version="dsComponentDetails.version"
      @keyup.enter.prevent="getSpecificPage"
    />
  </div>
</template>

<script>
import SbText from '@src/components/Text/SbText.vue';
import SbTextInput from '@src/components/Input/SbTextInput.vue';
import { versionedComponentsMixin } from '@src/mixins/versionedComponents';

export default {
  name: 'SbPaginationInput',
  components: {
    SbTextInput,
    SbText,
  },
  mixins: [versionedComponentsMixin],
  inject: ['pagination', 'fetchPage'],
  props: {
    labelText: {
      type: String,
      required: false,
      default: null,
    },
  },
  data: () => ({
    pageNum: null,
  }),
  computed: {
    totalPages() {
      return this.pagination.totalPages;
    },
    currentPage() {
      return this.pagination.currentPage;
    },
  },
  mounted() {
    this.pageNum = `${this.currentPage}`;
  },
  methods: {
    getSpecificPage(e) {
      e.target.blur();
      const num = Number.parseInt(this.pageNum, 10);
      if (Number.isNaN(num)) return;
      const pageToFetch = Math.max(Math.min(num, this.totalPages), 1);
      this.fetchPage(pageToFetch);
    },
  },
};
</script>

<style lang="scss">
@import '@src/components/Pagination/style/sb-pagination-input.scss';
</style>
